import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { ContasService } from 'src/app/services/contas.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';
import { BancosService } from 'src/app/services/bancos.service';

@Component({
    selector: 'app-modal-atualiza-contas',
    templateUrl: './modal-atualiza-contas.component.html',
    providers: [ContasService]
})

export class ModalAtualizaContasComponent implements OnInit {

    modalRef: NgbModalRef;
    public conta: any;
    public listaBancos = [];

    constructor(
        private appService: AppService,
        private contasService: ContasService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private dadosCargasService: DadosCargasService,
        private bancosService: BancosService,
    ) { }

    ngOnInit(): void {
        this.conta = this.modalRef.componentInstance.conta;
        this.bancosService.getAll()
        .subscribe(res => {
            this.listaBancos = res.data;
        }, error => {
            this.spinner.hide();
        });
    }

    atualizar() {
        this.update(this.conta);
    }

    update(conta) {
        this.spinner.show();
        this.toastrService.clear();

        this.contasService.update(conta)
            .subscribe(res => {
                this.toastrService.success("Conta atualizada!.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'atualizado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível atualizar a conta!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}